export const topicTypes = ['STANDARD', 'EVENT', 'OFFER'] as const
export const availablePostServices = ['google_map', 'docomo', 'yahoo_map'] as const

export const maxPostImageNum: Record<typeof availablePostServices[number], number> = {
  'google_map': 1,
  'docomo': 1,
  'yahoo_map': 1,
}

export const availablePostImageTypes: Record<typeof availablePostServices[number], string[]> = {
  'google_map': ['JPG', 'JPEG', 'PNG'],
  'docomo': ['JPG', 'JPEG', 'PNG'],
  'yahoo_map': ['JPG', 'JPEG', 'PNG'],
}

export const minPostImageWidth: Record<typeof availablePostServices[number], number> = {
  'google_map': 250,
  'docomo': 250,
  'yahoo_map': 720,
}

export const minPostImageHeight: Record<typeof availablePostServices[number], number> = {
  'google_map': 250,
  'docomo': 250,
  'yahoo_map': 720,
}

export const maxImageMbSize: Record<typeof availablePostServices[number], number> = {
  'google_map': 5000,
  'docomo': 5000,
  'yahoo_map': 10000,
}
